import { ClaimDocumentInfo, claimInfo, ClaimPaymentInfo, ClaimSearchRequest, reimburseClaimInfo } from "../redux/slice/claim/ClaimSlice";
import { http } from "./http";
import { GET_CLAIM_BY_ID_URL, GET_CLAIM_LIST, RECORD_CLAIM_PAYMENT, REIMBURSE_CLAIM_URL, SUBMIT_CLAIM_URL, UPDATE_CLAIM_STATUS, UPLOAD_CLAIM_DOCUMENT_URL } from "./URL";

export const getClaimList = async (searchData: ClaimSearchRequest) => {
    try {
        const response = await http.post(GET_CLAIM_LIST, searchData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const submitClaim = async (data: claimInfo) => {
    try {
        const response = await http.post(SUBMIT_CLAIM_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const submitReimbursedClaim = async (data: reimburseClaimInfo) => {
    try {
        const response = await http.post(REIMBURSE_CLAIM_URL, data);
        return response;
    } catch (error) {
        throw error;
    }
};

export const getClaimById = async (claimId: number) => {
    try {
        const response = await http.post(`${GET_CLAIM_BY_ID_URL}?claimId=${claimId}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const addClaimPayment = async (paymentData: ClaimPaymentInfo) => {
    try {
        const response = await http.post(RECORD_CLAIM_PAYMENT, paymentData);
        return response;
    } catch (error) {
        throw error;
    }
};

export const updateClaimStatusByClaimId = async (claimId: number, claimStatus: string) => {
    try {
        const response = await http.post(`${UPDATE_CLAIM_STATUS}?claimId=${claimId}&claimStatus=${claimStatus}`);
        return response;
    } catch (error) {
        throw error;
    }
};

export const uploadClaimDocumentData = async (documentInfo: ClaimDocumentInfo) => {
  try {
    const response = await http.post(UPLOAD_CLAIM_DOCUMENT_URL, documentInfo);
    return response;
  } catch (error) {
    throw error;
  }
};